import { BrandKit } from "@redotech/redo-model/brand-kit";
import { SignupFormInstance } from "@redotech/redo-web/marketing/signup-form/signup-form-instance";
import { memo, useContext, useMemo } from "react";
import { RedoShopifyRpcClientContext } from "../../../client/redo-shopify-rpc-client";

export const SignupFormInstanceWrapper = memo(
  function SignupFormInstanceWrapper({
    brandKit,
    utmParams,
  }: {
    brandKit: BrandKit;
    utmParams: string;
  }) {
    const client = useContext(RedoShopifyRpcClientContext);
    const shopifyCustomerId = useMemo(
      () =>
        (window as any).ShopifyAnalytics?.meta?.page?.customerId?.toString() ??
        null,
      [],
    );
    return (
      <SignupFormInstance
        brandKit={brandKit}
        rpcClient={client}
        shopifyCustomerId={shopifyCustomerId}
        site="marketing"
        utmParams={utmParams}
      />
    );
  },
);
